import { Resolution } from '../utils/MathUtils';

export default {
  props: {
    headless: Boolean,
    includeBackground: Boolean,
    fullTexture: Boolean,
    resolution: {
      type: Number,
      default: Resolution.PRINT,
      validator(v) {
        return Object.values(Resolution).includes(v);
      },
    },
  },
};
